/**
 * SxaProcessAreaResultTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
    resultlabel: {
        fontSize: 14,
        marginBottom: 4,
    },
    resultscore: {
        fontSize: 14,
        marginBottom: 4,
    },
});

class SxaProcessAreaResultTile extends React.Component {
    constructor(props) {
        super(props);
        this.state = { par: props.par };
    }

    /*
    componentDidUpdate(prevProps, prevState) {
        console.log("ProcessArea_Result.componentDidUpdate()");
    }
    */

    updateResult = (newPAR) => {
        //console.log("ProcessArea_Result.updateResult()");

        if (newPAR) {
            //console.log("New PAR " + newPAR.oid + "; " + newPAR.name);

            // Force re-render
            // Use function callback version
            this.setState( par => ({ par: newPAR }) );
        }
    }

    /*
    Debug state:
    <Typography align="left" className={classes.resultlabel} >
        PA ID {this.state.par.oid}: {this.state.par.name} Result
    </Typography>
    <Typography align="left" className={classes.resultlabel} >
        Score: {this.state.par.scoreComputed? this.state.par.score : "Not Yet"};
        Qs: {this.state.par.completedQuestionCount} / {this.state.par.questionCount}
    </Typography>
    <div style={{background: "lightgrey"}}>

    Removed label from score bar:
    {(this.state.par.completedQuestionCount === 0)?
                                <text x="6" y="14" fontFamily="Verdana" fontSize="12" fill="#1e2b56"> Questions Not Started </text>
                                : ""
                            }
     */
    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                { this.state.par ? (
                    <div>
                        <Grid container spacing={0} style={{padding: 0}}
                              direction="row" justify="space-evenly" alignItems="stretch">
                            <Grid item xs={6} sm={6} lg={6} xl={6}>
                                <Typography align="left" className={classes.resultlabel} >
                                    {this.state.par.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={6} xl={6}>
                                <Typography align="right" className={classes.resultscore} >
                                    {this.state.par.completedQuestionCount} / {this.state.par.questionCount}
                                </Typography>
                            </Grid>
                        </Grid>
                        <svg width="100%" height="20">
                            <rect x="0" y="0" width="100%" height="20" fill="#84848d"/>
                            <rect x="1" y="1" width="99%" height="18" fill="white" />
                            {this.state.par.scoreComputed ?
                                <rect x="0" y="0" width={this.state.par.score + "%"} height="20" fill="#2e457b"/>
                                :
                                <rect x="1" y="1" width="99%" height="18"
                                      fill={this.state.par.completedQuestionCount === 0? "white": "#ff8919"} />
                            }
                            {(this.state.par.scoreComputed !== true)?
                                <text x="6" y="14" fontFamily="Verdana" fontSize="12" fill="white"> In Progress </text>
                                :
                                <text x="6" y="14" fontFamily="Verdana" fontSize="12"
                                      fill={this.state.par.score > 5? "white": "#1e2b56"}>
                                    {this.state.par.score}
                                </text>
                            }
                        </svg>
                    </div>
                ) : "No Process Area found"}
            </React.Fragment>
        );
    }
}

SxaProcessAreaResultTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaProcessAreaResultTile);